export const SimilarityViewMode = {
    'CREATE': 'CREATE',
    'EDIT': 'EDIT',
    'CLONE': 'CLONE'
};
